// extracted by mini-css-extract-plugin
module.exports = {"event-content":"E01EventDetail_event-content__c9xZh"};